const APIPaths = {
  apiEndPoint: "https://app.atvnewsonline.com/epaper/v2/public/",
  ePaperGetRecommendation: "epaper_get_recommendation",
  ePaperGetDetails: "epaper_get_details",
  increaseReadCount: "increase_read_count",
  ePaperGetList: "epaper_get_list",
};

export default APIPaths;
